import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Leaf } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user && user !== false && user !== null) {
    return <Navigate to="/admin" replace />;
  }

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    const r = await login(email, password);
    setBusy(false);
    if (r.ok) {
      toast.success("Signed in");
      navigate("/admin", { replace: true });
    } else {
      toast.error(r.error || "Login failed");
    }
  }

  return (
    <div className="relative min-h-screen bg-forest text-white grid lg:grid-cols-2 grain overflow-hidden">
      <div className="hidden lg:flex flex-col justify-between p-14 bg-forest-gradient">
        <div className="flex items-center gap-2.5">
          <span className="grid place-items-center h-9 w-9 rounded-lg bg-white/10 text-white"><Leaf size={18}/></span>
          <span className="font-heading font-semibold text-lg">Be Green Group</span>
        </div>
        <div>
          <h1 className="font-heading text-4xl font-semibold leading-[1.05] max-w-md">
            Commercial PPA operations, in one place.
          </h1>
          <p className="mt-4 text-white/70 max-w-md leading-relaxed">
            Review applications, score leads and generate indicative proposals for Australian
            businesses adopting on-site solar and battery energy.
          </p>
        </div>
        <p className="text-xs text-white/50">© {new Date().getFullYear()} Be Green Group</p>
      </div>
      <div className="flex items-center justify-center p-8 bg-white text-forest">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
          <p className="text-xs tracking-[0.18em] uppercase font-semibold text-forest/80 mb-3">Admin sign in</p>
          <h2 className="font-heading text-3xl font-semibold mb-2">Sign in to your dashboard</h2>
          <p className="text-neutral-500 text-[14px] mb-8">Access is restricted to authorised Be Green Group staff.</p>

          <label className="block mb-4">
            <span className="text-[13px] font-semibold">Email</span>
            <Input
              className="mt-1.5"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
              placeholder="admin@begreengroup.com.au"
              required
              autoComplete="email"
            />
          </label>
          <label className="block mb-6">
            <span className="text-[13px] font-semibold">Password</span>
            <Input
              className="mt-1.5"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
              required
              autoComplete="current-password"
            />
          </label>
          <Button
            type="submit"
            disabled={busy}
            data-testid="admin-login-submit"
            className="w-full h-12 rounded-full bg-forest hover:bg-forest/90 text-white font-semibold"
          >
            {busy ? "Signing in..." : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
